// test2958
(2958 && 0);
